import Home from "./pages/Home";

function App() {
  return (
    <div className="w-screen h-screen pt-10 px-6">
      <Home />
    </div>
  );
}

export default App;
